const FORM_FIELDS_INPUT_SELECTOR = '.bz-forms-field input, .bz-forms-field textarea, .bz-forms-field select';

export class FormModule {
	constructor() {
		this.init();

		window.addEventListener('pageshow', () => {
			this.runOnPageShowEvent();
		});
	}

	init() {
		$(document).on('focus', FORM_FIELDS_INPUT_SELECTOR, function (event) {
			$(event.currentTarget).closest('.bz-forms-field').addClass('bz-forms-field--active');
		})
		.on('blur', FORM_FIELDS_INPUT_SELECTOR, function (event) {
			$(event.currentTarget).closest('.bz-forms-field').removeClass('bz-forms-field--active');
		})
		.on('change', FORM_FIELDS_INPUT_SELECTOR, function (event) {
			const value = $(event.currentTarget).val();

			if (value.length) {
				$(event.currentTarget).closest('.bz-forms-field').addClass('bz-forms-field--filled');
			} else {
				$(event.currentTarget).closest('.bz-forms-field').removeClass('bz-forms-field--filled');
			}
		});
	}

	runOnPageShowEvent() {
		const fields = document.querySelectorAll(FORM_FIELDS_INPUT_SELECTOR);

		fields.forEach((field) => {
			if (field.value.length) {
				field.closest('.bz-forms-field').classList.add('bz-forms-field--filled');
			} else {
				field.closest('.bz-forms-field').classList.remove('bz-forms-field--filled');
			}
		});
	}

}
